export default __webpack_public_path__ + "static/media/teamInvites.63d6acdc.svg";